import { useState, useEffect } from 'react';
import XLight from '@/assets/xLight.svg';
import Modal from '../../general/Modal';

interface FolderNameDialogProps {
  show: boolean;
  title?: string;
  initialValue?: string;
  onOk: (name: string) => void;
  onCancel: () => void;
}

export default function FolderNameDialog({
  show,
  title = 'Folder name',
  initialValue = '',
  onOk,
  onCancel,
}: FolderNameDialogProps) {
  const [name, setName] = useState(initialValue);

  useEffect(() => {
    setName(initialValue);
  }, [initialValue, show]);

  const handleOk = () => {
    if (name.trim()) {
      onOk(name.trim());
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleOk();
    }
  };

  return (
    <Modal open={show} onClose={onCancel} contanerClassName="w-[500px] max-w-[90vw] bg-white shadow-xl">
      <div className="flex items-center justify-between p-4">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        <XLight className="h-6 w-6 cursor-pointer hover:bg-gray-100" onClick={onCancel} />
      </div>
      <div className="w-full max-w-lg min-w-[200px] px-4 pb-10">
        <div className="relative flex items-center gap-3">
          <div className="relative w-full rounded-md border-2">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={handleKeyDown}
              className="peer ease text-black-700 hover:border-black-300 focus:border-black-400 placeholder:text-black-400 w-full rounded-md border border-slate-200 bg-transparent px-3 py-2 pr-8 text-sm shadow-sm transition duration-300 focus:shadow focus:outline-none"
              autoFocus
            />
            <label className="text-black-900 peer-focus:text-black-400 absolute top-2.5 left-2.5 origin-left transform cursor-text bg-white px-1 text-sm transition-all peer-focus:-top-2 peer-focus:left-2.5 peer-focus:scale-90 peer-focus:text-xs">
              Name
            </label>
            {name && (
              <button
                onClick={() => setName('')}
                className="text-black-400 hover:text-black-600 absolute top-1/2 right-2 mr-3.5 -translate-y-1/2 cursor-pointer text-xl font-bold"
              >
                ×
              </button>
            )}
          </div>
          <button
            onClick={handleOk}
            disabled={!name.trim()}
            className="cursor-pointer rounded-full bg-gray-500 p-2 text-white hover:bg-gray-600 disabled:cursor-not-allowed disabled:opacity-30"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </button>
        </div>
      </div>
    </Modal>
  );
}
